;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type", "return_url", "status_api_url"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      base_url: "",
      total_amount: 0,
      shortcode: null,
      gateway: null,
      stkOpen: false,
      stk_phone: null,
      show_uba_content: false,
      hide_proceed: false,
      initiating: false,
      iframe: null,
      iframeDoc: null,
      html: "",
      error: null,
      gateway_id: null,
      toggle_message: "Click here to proceed",
      payment_instructions: "",
      content_div: null
    };
  },

  computed: {
    valid_phone: function valid_phone() {
      if (this.stk_phone) {
        if (this.stk_phone.match(/\d{9}/g)) {
          return true;
        }
      }
      return false;
    }
  },
  created: function created() {
    var id = this.$attrs["gid"];
    this.payment_instructions = this.$attrs["instructions"];
    this.div_id = "mpambaProcessingModal" + id;
    this.content_div = "contentDivPamba" + id;
  },
  mounted: function mounted() {
    var _this = this;

    window.jQuery = _jquery2.default;
    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.shortcode = this.$attrs["shortcode"];
    this.gateway = this.$attrs["gid"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];
    this.gateway_id = this.$attrs["gid"];
    this.set_total_amount();
    this.write_instructions(this.content_div, this.payment_instructions);
    $("#mpambaProcessingModal").on("hidden.bs.modal", function () {
      _this.destroyTimer();
    });
  },
  methods: {
    write_instructions: function write_instructions(div, instructions) {
      $("#" + div).html(instructions);
    },

    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },
    toggleMpambaStkOpen: function toggleMpambaStkOpen() {
      if (this.stkOpen) {
        this.stkOpen = false;
        this.toggle_message = "Click here to proceed";
      } else {
        this.toggle_message = "Click here to close";
        this.stkOpen = true;
      }
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    stk_menu: function stk_menu() {
      var _this2 = this;

      this.initiating = true;
      var urlIs = this.base_url + "/api/payment/mpamba/checkout";
      var api_headers = {
        Authorization: "****"
      };
      var params = {
        invoice_number: this.invoice_number,
        gateway_id: this.gateway,
        amount: this.total_amount,
        msisdn: this.stk_phone,
        callback_url: this.callback_url,
        return_url: this.return_url
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _this2.initiating = false;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Request Failed (422). Try Later or Pay Directly to the bank"
          });
        } else {
          _this2.initiating = false;

          _this2.stk_phone = null;
          _this2.initiating = false;
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Check your phone for instructions",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function (error) {
        _this2.initiating = false;
        _this2.show_uba_content = false;
        _this2.hide_proceed = false;
        $("#mpambalProcessingModal").hide();
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Request Failed. Try Later or Pay Directly to the bank"
        });
      }).then(function () {
        _this2.initiating != true;
        _this2.stk_phone = null;
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"mpambaProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"mpambaProcessingLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('invoice-summary',{attrs:{"invoice":_vm.invoice,"gateway_name":"Mpamba","currency":_vm.currency,"online_convenience_fee":_vm.fee,"total_amount":_vm.total_amount,"amount_net":_vm.invoice_amount}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.toggleMpambaStkOpen()}}},[_vm._v(_vm._s(_vm.toggle_message))]),_vm._v(" "),(_vm.stkOpen)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("Phone Number\n                        "),(!_vm.valid_phone)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("* required")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stk_phone),expression:"stk_phone"}],staticClass:"form-control",attrs:{"type":"tel","maxlength":"13","placeholder":"Enter a valid phone number e.g 8.."},domProps:{"value":(_vm.stk_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stk_phone=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.valid_phone)?_c('div',{staticClass:"row"},[(_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n                        Processing ...\n                      ")]):_vm._e(),_vm._v(" "),(!_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":_vm.stk_menu}},[_vm._v("\n                        Initiate Payment\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.payment_instructions)?_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Payment Instructions")]),_vm._v(" "),_c('div',{attrs:{"id":_vm.content_div},domProps:{"innerHTML":_vm._s(_vm.payment_instructions)}})]):_vm._e(),_vm._v(" "),_c('br')]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"mpamba","poll_external":"true","gateway_id":_vm.gateway_id,"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}})],1)],1)])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8539b3f0", __vue__options__)
  } else {
    hotAPI.reload("data-v-8539b3f0", __vue__options__)
  }
})()}